const translations = {
    en: {
        shared: {
            layouts: {
                base: {
                    cookie_banner_text: "More information about our use of cookies and privacy agreement.",
                    cookie_banner_accept_button_text: "Accept"
                }
            }
        }
    },
    de: {
        shared: {
            layouts: {
                base: {
                    cookie_banner_text: "Weitere Informationen über unsere Verwendung von Cookies und Datenschutzvereinbarung.",
                    cookie_banner_accept_button_text: "Accept"
                }
            }
        }
    },
    es: {
        shared: {
            layouts: {
                base: {
                    cookie_banner_text: "Más información sobre nuestro uso de cookies y acuerdo de privacidad.",
                    cookie_banner_accept_button_text: "Accept"
                }
            }
        }
    },
    fr: {
        shared: {
            layouts: {
                base: {
                    cookie_banner_text: "Plus d'informations sur notre utilisation des cookies et notre accord de confidentialité.",
                    cookie_banner_accept_button_text: "Accept"
                }
            }
        }
    },
    it: {
        shared: {
            layouts: {
                base: {
                    cookie_banner_text: "Maggiori informazioni sull'utilizzo dei cookie e l'accordo sulla privacy.",
                    cookie_banner_accept_button_text: "Accetta"
                }
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/shared/layouts/Base.js